module.exports = __webpack_public_path__ + "static/crayon-2b93fe58345ec7bbdde119f4cfd31af7.png";